import { Link } from "react-router-dom";
import { SocialIconButtons } from "@/components/site/SocialIcons";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-ink" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-24">
      <div className="flex flex-col gap-12 md:flex-row md:items-end md:justify-between">
        <div>
          <Link to="/" className="flex items-center gap-3" data-testid="footer-logo">
            <img src="/logo-192.png" alt="Fore The Hell Of It logo" className="h-12 w-auto object-contain" data-testid="footer-logo-image" />
            <span className="font-display text-2xl font-extrabold uppercase tracking-tight">
              Fore The Hell <span className="text-brand-accent">Of It</span>
            </span>
          </Link>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-muted">
            A golf media brand covering the game, the grind, and the people in between.
            Course vlogs, match play, travel, and business conversations.
          </p>
          <div className="mt-8 flex gap-3">
            <SocialIconButtons testidPrefix="footer-social" />
          </div>
        </div>

        <nav className="grid grid-cols-2 gap-x-16 gap-y-4" data-testid="footer-nav">
          {[
            { to: "/about", label: "About" },
            { to: "/videos", label: "Videos" },
            { to: "/guests", label: "Guests" },
            { to: "/community", label: "Community" },
            { to: "/sponsor", label: "Sponsor With Us" },
            { to: "/contact", label: "Contact" },
            { to: "/contact?type=guest", label: "Become a Guest" },
          ].map((l) => (
            <Link
              key={l.label}
              to={l.to}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-muted transition-colors duration-300 hover:text-white"
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted">
          © {new Date().getFullYear()} Fore The Hell Of It. All rights reserved.
        </p>
        <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-white/30">
          Golf YouTube Channel · Golf Podcast · Golf Vlogs · Golf Travel · Golf Interviews
        </p>
      </div>
    </div>
  </footer>
);
